import { IPage, ISearchPage } from "@/types/AppTypes";
import { httpRequest } from "@/utils/HttpRequest";

//详情
export interface IPayableDetail {
    amountTotal?: string, // 3
    cumulative?: string, // 9998
    name?: string, // "北京綦齿"
    purchaseCode?: string, // "BJOH-YHCY-2224"
    saleCode?: string, // ""
    shipmentCode?: string, // ""
    code?: string, // ""
    settlementTime?: any, // "2022-04-21 10:11:20"
    typeName?: string, // ""
    uncollected?: string, // 998
    currencyCode?: string, // 998
    currency?: string, // 998
    currencyName?: string, // 998
}

//新增
export interface IPayableInsert extends IPayableDetail { }

//编辑
export interface IPayableUpdate extends IPayableInsert {
    id: string;
}

//搜索条件
export interface IPayableSearchFields { }

export interface IPayableSearch extends IPayableSearchFields, ISearchPage { }



class PayableService {
    async page(searchVo: IPayableSearch, config: object = {}) {
        const apiUrl = "/gtm/standingBooking/payment";
        return await httpRequest.post<IPage<IPayableDetail>>(apiUrl, searchVo, config);
    }
    //导出
    async export(searchVo: IPayableSearch) {
        const appPageUrl = "/gtm/standingBooking/payment/export";
        return await httpRequest.postFile<boolean>(appPageUrl, searchVo, { timeout: 300000 });
    }
    //下载模板
    async downloadTpl() {
        const appPageUrl = "/gtm/sale/downloadTpl";
        return await httpRequest.getFile(appPageUrl);
    }
}

export const payableService = new PayableService();
